import {CSSProperties, FC} from 'react';


export interface IIconPlaceholderProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPlaceholder: FC<IIconPlaceholderProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m12.313 18.657 4.021-4.1c2.221-2.265 2.221-5.937 0-8.201a5.61 5.61 0 0 0-8.043 0c-2.221 2.264-2.221 5.936 0 8.2l4.021 4.101Zm0 2.343-5.171-5.272c-2.856-2.912-2.856-7.633 0-10.544a7.213 7.213 0 0 1 10.341 0c2.856 2.911 2.856 7.632 0 10.544L12.313 21Zm0-8.887c.897 0 1.624-.742 1.624-1.657s-.727-1.657-1.624-1.657c-.898 0-1.626.742-1.626 1.657s.728 1.657 1.626 1.657Zm0 1.657c-1.795 0-3.25-1.484-3.25-3.314s1.455-3.314 3.25-3.314c1.794 0 3.25 1.484 3.25 3.314s-1.456 3.314-3.25 3.314Z" clipRule="evenodd" />
        </svg>
    );
};
